/** 图形转换相关函数 */
import { PointType, PointUpperCase } from '@/partTypes'

/**
 * @param {object | array} data 将点位{X,Y}转换为{x, y}
 * @returns
 */
export function toLowerCasePoint(data: PointUpperCase | PointUpperCase[]) {
  return Array.isArray(data)
    ? data.map((item) => {
        return {
          x: item.X,
          y: item.Y,
        }
      })
    : {
        x: data.X,
        y: data.Y,
      }
}
/**
 * @param {object | array} data 将点位{x, y}转换为{X, Y}
 * @returns
 */
export function toUpperCasePoint(data: PointType | PointType[]) {
  return Array.isArray(data)
    ? data.map((item) => {
        return {
          X: item.x,
          Y: item.y,
        }
      })
    : {
        X: data.x,
        Y: data.y,
      }
}

/**
 * @description 将路径的x和y轴互换
 * @param path 需要互换的路径
 * @returns 互换后的路径
 */
export function xyPointReverse(path: PointType[]) {
  return path.map((pt) => ({
    x: pt.y,
    y: pt.x,
  }))
}

/**
 * @description 判断当前路径是顺时针/逆时针，并将其转换成指定顺序
 * @param path 路径
 * @param direction 方向 cck 逆时针 ck 顺时针
 * @param isUpper 内部是否是大写的 XY 字段，默认是 false
 * @returns
 */
export function transformPathByDirection(
  path: (PointType | PointUpperCase)[],
  direction: 'ck' | 'cck',
  isUpper = false
) {
  const nPath = isUpper ? toLowerCasePoint(path as PointUpperCase[]) : path
  const isClockwise = window.ClipperLib.Clipper.Orientation(nPath)
  const isReverse =
    (isClockwise && direction === 'cck') || (!isClockwise && direction === 'ck')
  return isReverse ? path.reverse() : path
}

/**
 * @description 将路径转成线段数组
 * @param path 路径
 * @param direction 方向 cck 逆时针 ck 顺时针
 * @returns 线段数组
 */
export function transformPathToLine(
  path: PointType[],
  direction?: 'ck' | 'cck'
) {
  path = direction
    ? (transformPathByDirection(path, direction) as PointType[])
    : path
  const lines = []
  const len = path.length
  for (let i = 0; i < path.length; i++) {
    const nextIndex = (i + 1) % len
    lines.push({
      x1: path[i].x,
      y1: path[i].y,
      x2: path[nextIndex].x,
      y2: path[nextIndex].y,
    })
  }
  return lines
}
